var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6H6v3h1.5V6zM7.5 10.5H6v3h1.5v-3zM12 6h-1.5v3H12V6zM12 10.5h-1.5v3H12v-3zM7.5 15H6v3h1.5v-3zM12 15h-1.5v3H12v-3z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.5A1.5 1.5 0 0021 9h-4.5V3A1.5 1.5 0 0015 1.5H3A1.5 1.5 0 001.5 3v19.5h21v-12zM3 3h12v18H3V3zm13.5 18V10.5H21V21h-4.5z",
    fill: "#45464F"
  })));
}
export default SvgEnterprise;